import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
// import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
// import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_Responsive } from "../SlotGameType1_Responsive";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
// namespace SlotGames {

    export class RainbowTreasure_Responsive extends SlotGameType1_Responsive {


        
        protected override helpFactory: IHelpFactory = new RainbowTreasureHelpFactory();
        //SEND COLOR 
        protected override color: RewardColor =
            {
                color: "yellow",
                coloroutherStroke: "black",
                colorinnerStroke: "red",
            }
        //LED COLOR
		protected override ColorLed:string="255,255,0\n";
        constructor(multigameParams: MultigameParams, initData: SlotGameInitData, gameName: string = "RainbowTreasure") {
            super(multigameParams, initData, gameName);

            this.spinnableReelsParams.topBorderWidth = 7;
            this.spinnableReelsParams.bottomBorderWidth = 7;
        }

    }

    //Help Colorized
    class RainbowTreasureHelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new RainbowTreasureHelp(params);
        }
    }

    class RainbowTreasureHelp extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(64, 10, 5),rgb(89, 23, 8), rgb(140, 52, 20),rgb(89, 23, 8),rgb(64, 10, 5)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }

// }
